const STORE_ICON_GOOGLE = "https://cdn.shopify.com/s/files/1/0796/1959/files/google.png?v=1721205440";
const STORE_ICON_CALL = "https://cdn.shopify.com/s/files/1/0796/1959/files/fluent_call-28-regular_8421deb0-ea92-4d83-b8eb-83dd7c87b04b.png?v=1720074796";
const STORE_ICON_DIRECTION = "https://cdn.shopify.com/s/files/1/0796/1959/files/teenyicons_direction-solid.png?v=1719300137";
let productImage = document.querySelector('.stInventory-overlay');
productImage = productImage?.getAttribute('data-img');
let pdpProductTitle = document.querySelector('.stInventory-overlay');
pdpProductTitle = pdpProductTitle?.getAttribute('data-product');
let selectedSKU = document.querySelector('.stInventory-overlay');
selectedSKU = selectedSKU?.getAttribute('data-sku');
let productFullImage = `https://www.kushals.com/cdn/shop/${productImage}`;
let storeAvailableIcon = document.querySelector('.available-at-store');
let allStoresPopupState = null;

const ALL_STORES_POPUP_ID = 'ct-all-stores-popup';
let __pdpNearStoreRefreshRaf = 0;

function normalizeStoreCityName(value) {
  return String(value || '').trim().toLowerCase();
}

function getStoreCityName(store) {
  return store?.cityName || store?.city || store?.state || '';
}

function hasAnyGlobalModalOpen() {
  return Boolean(
    document.querySelector('.stInventory-overlay.show, .appmt-overlay.show')
  );
}

function normalizeSearchText(value) {
  return String(value || '').toLowerCase().trim();
}

function normalizeStoreIdentifier(value) {
  return String(value || '').trim().toLowerCase();
}

function parseNearStoreCodes(raw) {
  if (Array.isArray(raw)) {
    return raw
      .map((item) => String(item || '').trim().toUpperCase())
      .filter(Boolean);
  }
  const text = String(raw || '').trim();
  if (!text) return [];
  if (text[0] === '[' && text[text.length - 1] === ']') {
    try {
      const parsed = JSON.parse(text);
      if (Array.isArray(parsed)) {
        return parsed
          .map((item) => String(item || '').trim().toUpperCase())
          .filter(Boolean);
      }
    } catch (e) {}
  }
  return text
    .split(',')
    .map((item) => String(item || '').trim().toUpperCase())
    .filter(Boolean);
}

function getVariantNearStoresMap() {
  const overlay = document.querySelector('.stInventory-overlay');
  if (!overlay) return {};
  const raw = String(overlay.getAttribute('data-variant-near-stores') || '').trim();
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
}

function getSelectedVariantId() {
  const selectedFromForm = $("form [name='id']").val();
  if (selectedFromForm != null && String(selectedFromForm).trim() !== '') {
    return String(selectedFromForm).trim();
  }
  const selectedFromProductForm = $(".product-form [name='id']").val();
  if (selectedFromProductForm != null && String(selectedFromProductForm).trim() !== '') {
    return String(selectedFromProductForm).trim();
  }
  const selectedFromOption = $("form [name='id'] option:selected").val();
  if (selectedFromOption != null && String(selectedFromOption).trim() !== '') {
    return String(selectedFromOption).trim();
  }
  return '';
}

function refreshSelectedSkuFromDom() {
  const nextSku =
    $("form [name='id'] option:selected").data("sku") ||
    $(".product-form [name='id'] option:selected").data("sku") ||
    '';
  selectedSKU = String(nextSku || '').trim();
}

function getCurrentVariantNearStoreState() {
  const nearStoreMap = getVariantNearStoresMap();
  const variantId = getSelectedVariantId();
  const variantCodes = parseNearStoreCodes(nearStoreMap[variantId]);
  const normalizedVariantCodes = new Set(variantCodes.map((code) => normalizeStoreIdentifier(code)));

  if (normalizedVariantCodes.size > 0) {
    return {
      nearStoreCodeSet: normalizedVariantCodes,
      hasRestriction: true
    };
  }

  return {
    nearStoreCodeSet: new Set(),
    hasRestriction: false
  };
}

function getStoreShortCodes(store) {
  const codes = [
    store?.shortCode,
    store?.storeNameCode,
    store?.externalStoreCode
  ];
  return codes
    .map((value) => normalizeStoreIdentifier(String(value || '').trim()))
    .filter(Boolean);
}

function isInventoryAvailableForStore(nearStoreCodeSet, store, hasRestriction) {
  if (!hasRestriction) return true;
  const shortCodes = getStoreShortCodes(store);
  return shortCodes.some((code) => nearStoreCodeSet.has(code));
}

function getLocationStoreShortCodeSet() {
  try {
    const locationRaw = localStorage.getItem('location_store') || '{}';
    const locationData = JSON.parse(locationRaw);
    const stores = Array.isArray(locationData?.storeList) ? locationData.storeList : [];
    const codeSet = new Set();
    stores.forEach((store) => {
      getStoreShortCodes(store).forEach((code) => codeSet.add(code));
    });
    return codeSet;
  } catch (e) {
    return new Set();
  }
}

function getEffectiveNearStoreAvailabilityState() {
  const variantState = getCurrentVariantNearStoreState();
  const locationCodes = getLocationStoreShortCodeSet();

  if (!variantState.hasRestriction) {
    return {
      nearStoreCodeSet: locationCodes,
      hasRestriction: locationCodes.size > 0
    };
  }

  if (!locationCodes.size) {
    return variantState;
  }

  const mappedToNearby = new Set();
  variantState.nearStoreCodeSet.forEach((code) => {
    if (locationCodes.has(code)) mappedToNearby.add(code);
  });

  return {
    nearStoreCodeSet: mappedToNearby,
    hasRestriction: true
  };
}

function updatePdpAvailableAtStoreBadge() {
  if (!storeAvailableIcon || window.page !== 'product') return;
  try {
    const locationRaw = localStorage.getItem('location_store') || '{}';
    const locationData = JSON.parse(locationRaw);
    const stores = Array.isArray(locationData?.storeList) ? locationData.storeList : [];
    const nearStoreState = getEffectiveNearStoreAvailabilityState();
    const nearStoreCodeSet = nearStoreState.nearStoreCodeSet;
    const hasAvailability =
      stores.some((store) => isInventoryAvailableForStore(nearStoreCodeSet, store, nearStoreState.hasRestriction));

    storeAvailableIcon.style.display = hasAvailability ? 'flex' : 'none';
  } catch (e) {
    storeAvailableIcon.style.display = 'none';
  }
}

function refreshPdpStoreAvailabilityUI() {
  updatePdpAvailableAtStoreBadge();
  if (allStoresPopupState && Array.isArray(allStoresPopupState.storeList) && allStoresPopupState.storeList.length > 0) {
    updateStoreHTML(allStoresPopupState.storeList, allStoresPopupState.data || {});
  }
}

function schedulePdpStoreAvailabilityRefresh() {
  if (__pdpNearStoreRefreshRaf) cancelAnimationFrame(__pdpNearStoreRefreshRaf);
  __pdpNearStoreRefreshRaf = requestAnimationFrame(function () {
    __pdpNearStoreRefreshRaf = 0;
    refreshPdpStoreAvailabilityUI();
  });
}

// Backward-compatible hook used by main-product.liquid on variant change.
async function fetchStoreInventory() {
  refreshSelectedSkuFromDom();
  // Keep this as a lightweight compatibility hook.
  // main-product.liquid calls handleStoreData() right after this.
  return Promise.resolve();
}

async function getStoreReviews() {
    const geoOptions = { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 };

    const requestPosition = () => {
        navigator.geolocation.getCurrentPosition(
            showPosition_store,
            showError,
            geoOptions
        );
    };

    if (!navigator.geolocation) {
        KToast.error('Location is not supported on this device.');
        return;
    }

    if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions.query({ name: 'geolocation' }).then((result) => {
            if (result.state === 'denied') {
                KToast.error('Please enable location access to find nearby stores.');
            }
            requestPosition();
        }).catch(requestPosition);
    } else {
        requestPosition();
    }
}


if(storeAvailableIcon) {
  storeAvailableIcon.onclick = function() {
    const inventorySection = document.querySelector('.not-in-quickbuy.product-detail-accordion');
    if (inventorySection) {
      inventorySection.scrollIntoView({ behavior: 'smooth' });
    }
  };
}

// Function to call store API
async function callStoreAPI() {
    const locationData = localStorage.getItem('location_store');
    const obj = JSON.parse(locationData);

    let url;
    if (obj.postal) {
        if (obj.lat && obj.lng) {
            url = `${window.publicApiUrl}/near-by?latitude=${obj.lat}&longitude=${obj.lng}`;
        } else {
            url = `${window.publicApiUrl}/near-by?latitude=${obj.latitude}&longitude=${obj.longitude}`;
        }
    } else {
        url = `${window.publicApiUrl}/near-by?city=${obj.state}`;
    }

    try {
        let data;
        if (obj) {
            data = obj;
        } else {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            data = await response.json();
        }

        const waitForElements = () => {
            const appmtImage = document.querySelector('.appmt-image');

            if (appmtImage) {
                if (data?.store !== 0) {
                    appmtImage?.classList.remove('no-store-display');
                } else {
                    appmtImage?.classList.add('no-store-display');
                }
                observer.disconnect();
            }
        };

        // Set up a MutationObserver to watch for DOM changes
        const observer = new MutationObserver(() => {
            waitForElements();
        });

        // Start observing the body for child node changes
        observer.observe(document.body, { childList: true, subtree: true });
        return data;
    } catch (error) {
        throw new Error('Error fetching store data: ' + error.message);
    }
}

// Function to handle errors
function showError(error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            console.error("User denied the request for Geolocation.");
             KToast.error('Location access needed to find nearby stores.');
            break;
        case error.POSITION_UNAVAILABLE:
            console.error("Location information is unavailable.");
             KToast.error('Location information unavailable. Please try again.');
            break;
        case error.TIMEOUT:
            console.error("The request to get user location timed out.");
             KToast.error('Location request timed out. Please try again.');
            break;
        case error.UNKNOWN_ERROR:
            console.error("An unknown error occurred.");
             KToast.error('Unable to detect location.');
            break;
    }
}

// Function to show position
function showPosition_store(position) {
    const { latitude, longitude } = position.coords;
    // Pass the location to your function to handle data
    handleStoreData(latitude, longitude);
}

// Function to handle store data
async function handleStoreData(latitude, longitude) {
    try {
        const data = await callStoreAPI(latitude, longitude);
        if (data.storeList && data.storeList.length > 0) {
            updateStoreHTML(data.storeList, data);
        } else {
            // Handle the case when no store is found
            const moreStoreElement = document.querySelectorAll(".ct_more_store");
            const appmtImage = document.querySelector('.appmt-image');

            moreStoreElement?.forEach((ele) => {
                ele.style.display = "none";
            });

            if (appmtImage) {
                appmtImage.style.display = 'none';
            }
        }
    } catch (error) {
        console.error("Error fetching store data:", error);
    }
}

// Function to update HTML with store data
function updateStoreHTML(storeList, data) {
  let storeHTMLSliced = '';
  let storeHTMLAll = '';

  // Group by city
  const cityGroupedStores = storeList.reduce((acc, store) => {
    const city = store.cityName || "Unknown";
    if (!acc[city]) acc[city] = [];
    acc[city].push(store);
    return acc;
  }, {});

  const locationData = JSON.parse(localStorage.getItem('location_store'));
  const nearStoreState = getEffectiveNearStoreAvailabilityState();
  const nearStoreCodeSet = nearStoreState.nearStoreCodeSet;
  let reservedProducts = JSON.parse(sessionStorage.getItem("storeDetails")) || [];
  let selectedSkuForReservation = selectedSKU || $("form [name='id'] option:selected").data("sku");

  const cityFilter = data?.city || locationData?.city || '';
  const normalizedCityFilter = normalizeStoreCityName(cityFilter);
  const scopedStoreCount = normalizedCityFilter
    ? storeList.filter((store) => normalizeStoreCityName(getStoreCityName(store)) === normalizedCityFilter).length
    : storeList.length;
  const shouldShowViewAll = scopedStoreCount > 8;
  const storeCity = shouldShowViewAll
    ? `<a href="#" class="ct-view-all-stores" data-city="${String(cityFilter || '').toLowerCase()}">View All</a>`
    : '';

  // 🟢 Step 1: reorder stores inside each city (available first, then unavailable)
  Object.keys(cityGroupedStores).forEach(city => {
    const stores = cityGroupedStores[city].filter(Boolean);
    cityGroupedStores[city] = [
      ...stores.filter(store => store && isInventoryAvailableForStore(nearStoreCodeSet, store, nearStoreState.hasRestriction)),  // available
      ...stores.filter(store => store && !isInventoryAvailableForStore(nearStoreCodeSet, store, nearStoreState.hasRestriction)) // unavailable
    ];
  });

  // 🟢 Step 2: flatten city groups while respecting city order, limit 8
  let finalStores = [];
  Object.keys(cityGroupedStores).forEach(city => {
    if (finalStores.length < 8) {
      const remainingSlots = 8 - finalStores.length;
      finalStores = [...finalStores, ...cityGroupedStores[city].slice(0, remainingSlots)];
      if (storeAvailableIcon && finalStores[0] && isInventoryAvailableForStore(nearStoreCodeSet, finalStores[0], nearStoreState.hasRestriction)) {
        storeAvailableIcon.style.display = 'flex';
      }
    }
  });

  // 🟢 Step 3: generate HTML for sliced stores
  finalStores.forEach(store => {
    const inventoryIsAvailable = isInventoryAvailableForStore(nearStoreCodeSet, store, nearStoreState.hasRestriction);
    const isReserved = reservedProducts.some(
      (item) => Number(item.storeId) === store.id && Number(item.sku) === selectedSkuForReservation
    );

    storeHTMLSliced += generateStoreHTMLSliced(store, data, inventoryIsAvailable, isReserved);
  });

  // Generate HTML for all stores (no slice)
  storeList.forEach(store => {
    storeHTMLAll += generateStoreHTML(store);
  });

  allStoresPopupState = {
    storeList: Array.isArray(storeList) ? storeList : [],
    data: data || {},
    cityFilter: cityFilter,
    inventoryNearStoreCodes: Array.from(nearStoreCodeSet),
    inventoryRestrictionActive: nearStoreState.hasRestriction,
    reservedProducts: Array.isArray(reservedProducts) ? reservedProducts : [],
    selectedSKU: selectedSkuForReservation
  };

  // Inject into DOM
  const moreStoreElements = document.querySelectorAll(".ct_more_store");
  const appmtImage = document.querySelector('.appmt-image');

  if (moreStoreElements) {
    moreStoreElements.forEach((ele) => {
      if (ele.classList.contains('show-all-stores')) {
        ele.innerHTML = wrapStoreHTML(storeHTMLAll, "All Stores Near You", storeCity);
      } else {
        ele.innerHTML = wrapStoreHTML(storeHTMLSliced, "Stores Near You To Assist", storeCity);
      }
      ele.style.display = "block";
    });
  }

  
  if (appmtImage) {
    appmtImage.style.display = 'block';
  }
  document.dispatchEvent(new CustomEvent('storeLocator:storesRendered'));
}

function getAllStoresForPopup() {
  if (!allStoresPopupState || !Array.isArray(allStoresPopupState.storeList)) {
    return [];
  }

  const targetCity = normalizeStoreCityName(allStoresPopupState.cityFilter || allStoresPopupState.data?.city || '');
  let scopedStores = allStoresPopupState.storeList.filter(Boolean);

  if (targetCity) {
    const cityStores = scopedStores.filter((store) => normalizeStoreCityName(getStoreCityName(store)) === targetCity);
    if (cityStores.length > 0) scopedStores = cityStores;
  }

  const nearStoreCodeSet = new Set(
    (allStoresPopupState.inventoryNearStoreCodes || []).map((code) => normalizeStoreIdentifier(code))
  );
  const hasRestriction = !!allStoresPopupState.inventoryRestrictionActive;
  return [
    ...scopedStores.filter((store) => isInventoryAvailableForStore(nearStoreCodeSet, store, hasRestriction)),
    ...scopedStores.filter((store) => !isInventoryAvailableForStore(nearStoreCodeSet, store, hasRestriction))
  ];
}

function buildAllStoresPopupHTML() {
  const popupStores = getAllStoresForPopup();
  const nearStoreCodeSet = new Set(
    (allStoresPopupState?.inventoryNearStoreCodes || []).map((code) => normalizeStoreIdentifier(code))
  );
  const hasRestriction = !!allStoresPopupState?.inventoryRestrictionActive;
  const reservedProducts = Array.isArray(allStoresPopupState?.reservedProducts) ? allStoresPopupState.reservedProducts : [];
  const selectedSku = allStoresPopupState?.selectedSKU;

  return popupStores.map((store) => {
    const inventoryIsAvailable = isInventoryAvailableForStore(nearStoreCodeSet, store, hasRestriction);
    const isReserved = reservedProducts.some(
      (item) => Number(item.storeId) === store.id && Number(item.sku) === selectedSku
    );
    return generateStoreCardHTML(store, {
      cardClass: 'pdp-cards-stores',
      extraCardClass: 'ct-all-stores-popup__card',
      footerMode: 'inventory',
      inventoryIsAvailable,
      isReserved,
      isPopup: true
    });
  }).join('');
}

function getAllStoresPopupTitle() {
  const city = allStoresPopupState?.cityFilter || allStoresPopupState?.data?.city || '';
  return city ? `All Stores In ${city}` : 'All Stores Near You';
}

function ensureAllStoresPopup() {
  let popup = document.getElementById(ALL_STORES_POPUP_ID);
  if (popup) return popup;

  popup = document.createElement('div');
  popup.id = ALL_STORES_POPUP_ID;
  popup.innerHTML = `
    <div class="ct-all-stores-popup__backdrop" data-popup-close></div>
    <div class="ct-all-stores-popup__sheet" role="dialog" aria-modal="true" aria-label="All stores">
      <div class="ct-all-stores-popup__head">
        <h3 class="ct-all-stores-popup__title"></h3>
        <button type="button" class="ct-all-stores-popup__close" data-popup-close>&times;</button>
      </div>
      <div class="ct-all-stores-popup__body">
        <div class="ct-all-stores-popup__search-wrap">
          <input
            type="text"
            class="ct-all-stores-popup__search"
            placeholder="Search by store Name or Area"
            aria-label="Search stores"
          >
          <button type="button" class="ct-all-stores-popup__search-clear" aria-label="Clear search" title="Clear search">&times;</button>
        </div>
        <div class="ct-all-stores-popup__list"></div>
        <div class="ct-all-stores-popup__empty ct-all-stores-popup__empty--search" style="display:none;">
          No stores match your search.
        </div>
      </div>
    </div>
  `;

  popup.addEventListener('click', (event) => {
    if (event.target.closest('[data-popup-close]')) {
      closeAllStoresPopup();
    }
  });

  const searchInput = popup.querySelector('.ct-all-stores-popup__search');
  const searchClearBtn = popup.querySelector('.ct-all-stores-popup__search-clear');
  searchInput?.addEventListener('input', function () {
    if (searchClearBtn) {
      searchClearBtn.classList.toggle('show', Boolean(this.value && this.value.trim()));
    }
    filterAllStoresPopup(this.value || '');
  });
  searchClearBtn?.addEventListener('click', function () {
    if (!searchInput) return;
    searchInput.value = '';
    this.classList.remove('show');
    filterAllStoresPopup('');
    searchInput.focus();
  });

  document.body.appendChild(popup);
  return popup;
}

function filterAllStoresPopup(query) {
  const popup = document.getElementById(ALL_STORES_POPUP_ID);
  if (!popup) return;

  const normalizedQuery = normalizeSearchText(query);
  const storeCards = popup.querySelectorAll('.ct-all-stores-popup__list .store-more-box');
  const emptySearchState = popup.querySelector('.ct-all-stores-popup__empty--search');
  let visibleCount = 0;

  storeCards.forEach((card) => {
    const haystack = normalizeSearchText(card.textContent || '');
    const isVisible = !normalizedQuery || haystack.includes(normalizedQuery);
    card.style.display = isVisible ? '' : 'none';
    if (isVisible) visibleCount += 1;
  });

  if (emptySearchState) {
    emptySearchState.style.display = visibleCount === 0 ? 'block' : 'none';
  }
}

function openAllStoresPopup() {
  if (!allStoresPopupState || !Array.isArray(allStoresPopupState.storeList) || allStoresPopupState.storeList.length === 0) return;

  const popup = ensureAllStoresPopup();
  const titleEl = popup.querySelector('.ct-all-stores-popup__title');
  const listEl = popup.querySelector('.ct-all-stores-popup__list');
  const searchInput = popup.querySelector('.ct-all-stores-popup__search');
  const listHtml = buildAllStoresPopupHTML();

  titleEl.textContent = getAllStoresPopupTitle();
  listEl.innerHTML = listHtml || '<div class="ct-all-stores-popup__empty">No stores found for this city.</div>';
  if (searchInput) {
    searchInput.value = '';
    const searchClearBtn = popup.querySelector('.ct-all-stores-popup__search-clear');
    if (searchClearBtn) searchClearBtn.classList.remove('show');
    filterAllStoresPopup('');
  }

  // Trigger transition reliably, including first open right after DOM insertion.
  requestAnimationFrame(() => {
    popup.classList.add('show');
  });
  document.body.classList.add('mm-no-scroll');
}

function closeAllStoresPopup() {
  const popup = document.getElementById(ALL_STORES_POPUP_ID);
  if (!popup) return;

  popup.classList.remove('show');
  if (!hasAnyGlobalModalOpen()) {
    document.body.classList.remove('mm-no-scroll');
  }
}



// Helper to generate individual store HTML
function generateStoreHTML(store) {
  return generateStoreCardHTML(store, { cardClass: 'appmt-store-box', footerMode: 'appointment' });
}

function generateStoreHTMLSliced(store, data, inventoryIsAvailable = false, isReserved = false) {
  return generateStoreCardHTML(store, {
    cardClass: 'pdp-cards-stores',
    footerMode: 'inventory',
    inventoryIsAvailable,
    isReserved
  });
}

function generateStoreCardHTML(store, options = {}) {
  const {
    cardClass = 'pdp-cards-stores',
    extraCardClass = '',
    footerMode = 'inventory',
    inventoryIsAvailable = false,
    isReserved = false,
    isPopup = false
  } = options;

  const openingTime = convertTo12HourFormat(store.openingTime);
  const closingTime = convertTo12HourFormat(store.closingTime);
  const openTime = openingTime.split(" ")[0];
  const timeCheck = updateStoreTime(openTime, store.closingTime, closingTime);
  const city = store.city || 'Unknown City';
  const inventoryMetaClass = isPopup ? 'ct-store-inventory-meta' : 'store-inventory-footer';

  const footerHtml = footerMode === 'appointment'
    ? `
      <div class="store-more-footer">
        <button type="button" class="book-appmt-button" onclick="handleAppointmentAction(this)">Book Appointment</button>
      </div>
    `
    : `${window.page === 'product' ? `<div class="store-more-footer store-more-footer-inventory">
        <div class="store-inventory-footer ${!inventoryIsAvailable ? 'not-available' : ''}">
          <div class="${inventoryMetaClass} ${!inventoryIsAvailable ? 'not-available' : ''}">
            <img src="${productFullImage}" alt="product-mage">
            <span>${inventoryIsAvailable ? 'In Stock' : 'Out of Stock'}</span>
          </div>
          ${inventoryIsAvailable
            ? (isReserved
              ? `<button type="button" class="reserve-product" onclick="stInventoryReservationOpen(this)"> View Reservation</button>`
              : `<button type="button" class="reserve-product" onclick="handleInventoryAction(this)"> Reserve This Product </button>`)
            : ''}
        </div>
      </div>` : ''}`;

  return `
    <div class="store-more-box store-more-box-product ${cardClass} ${extraCardClass}" data-store-id="${store.id}">
      <div class="store-more-box-inner">
        <a class="store_pro-link ct_store_click" data-store="${store.name}" href="https://www.kushals.com/pages/store-details/${city}-${store.slug}">
          <div class="store-more-box-head">
            <div class="store-more-name">
              <span>${store.name}</span>
            </div>
            <div class="store-more-star">
              <img src="${STORE_ICON_GOOGLE}" width="30" height="30">
              <span>${store.rating}</span>
            </div>
          </div>
          <div class="store-more-text">
            ${store.address}
          </div>
        </a>
        <div class="call-dir-main">
          <a href="tel:${store.phone}" class="ct_store_call" data-storedir="${store.name}" data-storecall="${store.phone}" data-store="${store.name}">
            <div class="call-main">
              <div class="call-icon">
                <img src="${STORE_ICON_CALL}" alt="">
              </div>
              <span>Call Store</span>
            </div>
          </a>
          <div class="direction-main">
            <div class="direction-icon">
              <img src="${STORE_ICON_DIRECTION}" alt="">
            </div>
            <span><a class="ct_store_map" data-store="${store.name}" href="${store.direction}" target="_blank">Get Direction</a></span>
          </div>
          ${timeCheck}
        </div>
      </div>

      ${footerHtml}
    </div>
  `;
}


// Helper to wrap the stores with a header and storeCity
function wrapStoreHTML(storeHTML, heading, storeCity) {
    return `
        <div class="store-more-head">
            <span>${heading}</span>
            <div class="store-more-all ct_all_store">${storeCity}</div>

        </div>
        <div class="store-more-content near-stores">${storeHTML}</div>`;
}

// Function to convert time to 12-hour format
function convertTo12HourFormat(time) {
    let [hours, minutes] = time.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert hour to 12-hour format
    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
}

// Function to check store open/close time
function updateStoreTime(openTime, closeTime, storeCloseTime) {
    const currentTime = new Date();
    const openingDate = new Date(currentTime);
    const closingDate = new Date(currentTime);

    const [openHours, openMinutes] = openTime.split(':').map(Number);
    const [closeHours, closeMinutes] = closeTime.split(':').map(Number);

    openingDate.setHours(openHours, openMinutes, 0);
    closingDate.setHours(closeHours, closeMinutes, 0);

    if (closingDate <= openingDate) {
        closingDate.setDate(closingDate.getDate() + 1);
    }

    if (currentTime >= openingDate && currentTime < closingDate) {
        return `<div class="open-close-store"> <div class="dot"></div> <span>Open</span> </div>`;
    } else {
        return `<div class="open-close-store close_store"> <div class="dot"></div> <span>Closed</span> </div>`;
    }
}

jQuery(document).ready(function () {
    if (window.page === 'product') {
        refreshSelectedSkuFromDom();
        refreshPdpStoreAvailabilityUI();

        // Keep badge in sync with selected variant.
        $(document).on('change', "form [name='id'], .product-form [name='id']", function () {
            refreshSelectedSkuFromDom();
            schedulePdpStoreAvailabilityRefresh();
        });
        $(window).on('cc-variant-updated', function (event, args) {
            if (args && args.variant && args.variant.sku != null) selectedSKU = String(args.variant.sku || '').trim();
            else refreshSelectedSkuFromDom();
            schedulePdpStoreAvailabilityRefresh();
        });

        // Re-evaluate when location gets updated in localStorage.
        window.addEventListener('storage', function (event) {
            if (!event || !event.key) return;
            if (event.key === 'location_store' || event.key === 'current_location') {
                schedulePdpStoreAvailabilityRefresh();
            }
        });

        if (!window.__storeLocatorLocationStoragePatchApplied && window.localStorage) {
            window.__storeLocatorLocationStoragePatchApplied = true;
            const originalSetItem = window.localStorage.setItem;
            const originalRemoveItem = window.localStorage.removeItem;

            try {
                window.localStorage.setItem = function (key, value) {
                    const result = originalSetItem.apply(this, arguments);
                    if (key === 'location_store' || key === 'current_location') {
                        schedulePdpStoreAvailabilityRefresh();
                    }
                    return result;
                };
            } catch (e) {}

            try {
                window.localStorage.removeItem = function (key) {
                    const result = originalRemoveItem.apply(this, arguments);
                    if (key === 'location_store' || key === 'current_location') {
                        schedulePdpStoreAvailabilityRefresh();
                    }
                    return result;
                };
            } catch (e) {}
        }
    }

    if(window.page === 'product') {
        $(window).on("scroll.moreStore", function () {
            var scrollTop = $(window).scrollTop(); // Current scroll position
            var windowHeight = $(window).height(); // Viewport height
            var section = $(".ct_more_store "); // Target section
    
            if (section.length === 0) {
                return; // Exit if the section does not exist
            }
    
            var offset = section.offset().top; // Distance from top of the document to the section
            // Check if the section is in view
            if (scrollTop + windowHeight >= offset) {
                handleStoreData("123", "321"); // Call your function
                $(window).off("scroll.moreStore"); // Remove scroll listener to prevent further calls
            }
        });
    } else {
        const interval = setInterval(() => {
            if (localStorage.getItem('location_store')) {
                handleStoreData("123", "321");
                clearInterval(interval);
            }
        }, 1000);
    }
    

    if (localStorage.getItem('pin') != undefined) {
        var pin_get = localStorage.getItem('pin');
        jQuery(".clickpost-edd__drop_pincode-input").val(pin_get);
        pin_checker(pin_get);
    }

    jQuery(document).on("input", ".clickpost-edd__form .clickpost-edd__drop_pincode-input", function () {
        const input_pin_number = jQuery(".clickpost-edd__drop_pincode-input").val();
        if (input_pin_number.length === 6) {
            pin_check(input_pin_number);
            pin_checker(input_pin_number);
        } else if (input_pin_number == "") {
            jQuery(".ct_msg_show").hide();
        }
    });
});

function pin_checker(pin_number) {
    if (pin_number.length === 6) {
        jQuery(".clickpost-edd__drop_pincode-input").val(pin_number);
        jQuery(".clickpost-edd__form .clickpost-edd__submit-button").trigger("click");
    }
}

function count_date(c_date_no) {
    const d = new Date();
    d.setDate(d.getDate() + c_date_no);

    const date = d.getDate();
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const month = monthNames[d.getMonth()];

    const weekdayNames = [
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ];
    const weekday = weekdayNames[d.getDay()];

    return { date, week: weekday, month };
}

jQuery(document).on("click",".ct_store_call",function(){
    var store_name=jQuery(this).attr("data-store");
    clevertap.event.push("Call_Store", {
        "CallStore_Name":store_name
    });
});

$(document).on("click", ".ct_store_click", function () {
    const storeName = $(this).data("store");
    clevertap.event.push("Store_Name", { "Store Name": storeName });
});

$(document).on("click", ".ct_store_map", function () {
    const storeName = $(this).data("store");
    clevertap.event.push("Store_Name_Direction", { "Store Name direction": storeName });
});

$(document).on("click", ".ct_all_store a", function () {
    clevertap.event.push("MoreStores");
});

$(document).on("click", ".ct-view-all-stores", function (event) {
    event.preventDefault();
    openAllStoresPopup();
});

$(document).on("click", `#${ALL_STORES_POPUP_ID} .reserve-product`, function () {
    closeAllStoresPopup();
});

document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        closeAllStoresPopup();
    }
});


    const stInventoryOverlay = document.querySelector('.stInventory-overlay');
    const stInventoryModal = document.querySelector('.stInventory-modal');
    const stInventoryMiddle = document.querySelector('.stInventory-middle');
    const stInventorySuccess = document.querySelector('.stInventory-modal-success');
    const selectedStoreContent = document.querySelector('.selected-store-content');
    let storeId = '';

    let reservedProducts = JSON.parse(sessionStorage.getItem("storeDetails") || "[]");

    const handleInventoryAction = (button) => {
        const buttonParent = button.closest('.store-more-box');
        const storeName = buttonParent.querySelector('.store-more-name span')?.textContent.trim() || '';
        const storeDescription = buttonParent.querySelector('.store-more-text')?.textContent.trim() || '';
        const storeRating = buttonParent.querySelector('.store-more-star span')?.textContent.trim() || '';
        const storeCall = buttonParent.querySelector('.call-dir-main a')?.href.trim() || '';
        const storeDirection = buttonParent.querySelector('.ct_store_map')?.href.trim() || '';
        storeId = buttonParent.getAttribute('data-store-id');
        

        const callStoreDiv = document.querySelector('.selected-store-call');
        const storeDirectionDiv = document.querySelector('.selected-ct_store_map');

        callStoreDiv.setAttribute('href', storeCall);
        callStoreDiv.setAttribute('data-store', storeName);
        storeDirectionDiv.setAttribute('href', storeDirection);
        storeDirectionDiv.setAttribute('data-store', storeName);

        // Select all visible modals (in case there are multiple)
        const modals = document.querySelectorAll('.stInventory-modal, .stInventory-middle, .stInventory-modal-success');
        modals.forEach(modal => {
            const stInventoryStoreName = modal.querySelectorAll('.stInventory-store-list .store-more-name span');
            const stInventoryStoreDescription = modal.querySelectorAll('.stInventory-store-list .store-more-text');
            const stInventoryStoreRating = modal.querySelectorAll('.stInventory-store-list .store-more-star span');

            stInventoryStoreName.forEach((el) => el.textContent = storeName);
            stInventoryStoreDescription.forEach((el) => el.textContent = storeDescription);
            stInventoryStoreRating.forEach((el) => el.textContent = storeRating);
        });

        if (!stInventoryOverlay.classList.contains('show')) {
            document.body.classList.add('mm-no-scroll');
            stInventoryOverlay.classList.add('show');
        }
        stInventoryModal.classList.add('show');

        clevertap.event.push("Reserve_Btn_clicked", {
            "ReserveProduct_StoreName": storeName,
            "ReserveProduct_SKU": selectedSKU,
            "ReserveProduct_ProductName": pdpProductTitle
        });
    }

    const stInventoryMiddleAction = () => {
        stInventoryModal.classList.remove('show');
        stInventoryModal.classList.add('hide');
        stInventoryMiddle.classList.add('show');
    }

    const stInventorySuccessOpen = async () => {
        // check all the input fields for values
        const nameInput = stInventoryMiddle.querySelector('.selected-store-content .appmt-input-name');
        const numberInput = stInventoryMiddle.querySelector('.selected-store-content .appmt-input-num');
        const phoneNumberContainer = stInventoryMiddle.querySelector('.selected-store-content .appmt-number-container');
        const isValidPhoneNumber = (val) =>
          /^[6-9]\d{9}$/.test(String(val || '').trim()) &&      // starts 6–9
          !/^(\d)\1{9}$/.test(val) &&                           // not 0000000000, 1111111111, etc.
          !['1234567890','0123456789','9876543210','0987654321'].includes(val);
        
        let validNumber = isValidPhoneNumber(numberInput.value.trim());
        const emailInput = stInventoryMiddle.querySelector('.selected-store-content .appmt-input-email');
        const emailValue = emailInput.value.trim();
        const isValidEmail = emailValue.includes('@');
        if (!nameInput.value || !numberInput.value || !emailInput.value || !isValidEmail || !validNumber || numberInput.value.length < 10) {
            if (!nameInput.value) {
                nameInput.classList.add('appmt-input-warning', 'shake');
                setTimeout(() => nameInput.classList.remove('shake'), 500);
            }

            if(!emailInput.value) {
                emailInput.classList.add('appmt-input-warning', 'shake');
                setTimeout(() => emailInput.classList.remove('shake'), 500);
            }

            if(!isValidEmail) {
                emailInput.classList.add('appmt-input-warning', 'shake');
                setTimeout(() => emailInput.classList.remove('shake'), 500);
            }

            if (!numberInput.value || numberInput.length < 10 || !validNumber) {
                numberInput.classList.add('appmt-input-warning');
                phoneNumberContainer.classList.add('shake');
                setTimeout(() => phoneNumberContainer.classList.remove('shake'), 500);
            }

            if (navigator.vibrate) {
                navigator.vibrate(100);
            }
            return;
        }

        const apiResult = await callReserveStoreAPI(nameInput.value, numberInput.value, emailInput.value);
        if (apiResult) {
            stInventoryModal.classList.remove('show');
            stInventoryModal.classList.remove('hide');
            stInventoryMiddle.classList.remove('show');
            stInventoryMiddle.classList.add('hide');
            stInventorySuccess.classList.add('show');
        }
    }

    const stInventoryReservationOpen = (button) => {
        const buttonParent = button.closest('.store-more-box');
        const storeName = buttonParent.querySelector('.store-more-name span')?.textContent.trim() || '';
        const storeDescription = buttonParent.querySelector('.store-more-text')?.textContent.trim() || '';
        const storeCall = buttonParent.querySelector('.call-dir-main a')?.href.trim() || '';
        const storeDirection = buttonParent.querySelector('.ct_store_map')?.href.trim() || '';
        storeId = buttonParent.getAttribute('data-store-id');
        document.querySelector('.stInventory-modal-success .selected-store-call').setAttribute('href', storeCall);
        document.querySelector('.stInventory-modal-success .selected-ct_store_map').setAttribute('href', storeDirection);
        const modals = document.querySelector('.stInventory-modal-success');
        modals.querySelector('.store-more-name span').textContent = storeName;
        modals.querySelector('.store-more-text').textContent = storeDescription;
        document.body.classList.add('mm-no-scroll');
        stInventoryOverlay.classList.add('show');
        stInventorySuccess.classList.add('show');

        let storedDetails = JSON.parse(sessionStorage.getItem("storeDetails") || "[]");

        storedDetails.forEach((product) => {
            if (product.storeId === storeId) {
                stInventorySuccess.querySelector('.stInventory-prd-heading').textContent = `Booking ID: ${product.bookingId}`;
            }
        });
    }
    
    async function callReserveStoreAPI(customerName, phoneNumber, emailId) {
        let twoDaysFromNow = new Date();
        twoDaysFromNow.setDate(twoDaysFromNow.getDate() + 2);
        // Format date as YYYY-MM-DD
        const yyyy = twoDaysFromNow.getFullYear();
        const mm = String(twoDaysFromNow.getMonth() + 1).padStart(2, '0');
        const dd = String(twoDaysFromNow.getDate()).padStart(2, '0');
        const formattedDate = `${yyyy}-${mm}-${dd}`;

        const url = `${window.apiUrl}/store-visit`;
        const data = {
            customerName: customerName,
            phoneNumber: phoneNumber,
            emailId: emailId,
            productName: pdpProductTitle,
            sku: selectedSKU,
            visitDate: formattedDate,
            purpose: `Reserve Product: ${pdpProductTitle} SKU:${selectedSKU} `,
            storeId: storeId,
            sourceType: "Product_Reservation"
        };

        try {
            const options = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            };

            const response = await fetch(url, options);
            const responseData = await response.json();

            if (!response.ok) {
                showError('Please try again later');
                console.error(`API error: ${responseData.message || response.statusText}`);
                return false;
            } else {
                let stInventoryId = document.querySelector('.stInventory-prd-heading');
                let selectedSKU = $("form [name='id'] option:selected").data("sku");

                reservedProducts.push({
                    customerName: customerName,
                    phoneNumber: phoneNumber,
                    customerEmail: emailId,
                    storeId: storeId,
                    sku: selectedSKU,
                    bookingId: responseData.id
                });

                sessionStorage.setItem("storeDetails", JSON.stringify(reservedProducts));

                stInventoryId.innerHTML = `Booking ID: ${responseData.id}`;

                let allStores = document.querySelectorAll('.store-more-box.pdp-cards-stores')
                let matchedStoreId = allStores.forEach((e) => {
                    if (e.getAttribute('data-store-id') === storeId) {
                        e.querySelector('.reserve-product').textContent = 'View Reservation';
                        e.querySelector('.reserve-product').setAttribute('onclick', 'stInventoryReservationOpen(this)');
                    }
                });

                clevertap.profile.push({
                  "Site": {
                    "Name": customerName,
                    "Phone": `+91${phoneNumber}`,
                    "Email": emailId,
                // optional fields. controls whether the user will be sent email, push etc.
                    "MSG-email": false,
                    "MSG-push": true,
                    "MSG-sms": true,
                    "MSG-whatsapp": true,
                  }
                });

                let storeName = document.querySelector('.stInventory-modal-success');
                storeName = storeName.querySelector('.store-more-name span')?.textContent.trim() || '';
                clevertap.event.push("Reserve_Submit_clicked", {
                    "ReserveSubmit_StoreName": storeName,
                    "ReserveSubmit_SKU": selectedSKU,
                    "ReserveSubmit_ProductName": pdpProductTitle,
                    "ReserveSubmit_StoreID": storeId,
                    "ReserveSubmit_Date": formattedDate,
                    "ReserveStoreDirection": document.querySelector('.selected-ct_store_map').getAttribute('href'),
                    "ReserveStoreCall": document.querySelector('.selected-store-call').getAttribute('href'),
                    "ReserveSubmit_CustomerEmail": emailId,
                    "ReserveSubmit_CustomerPhone": phoneNumber,
                    "ReserveSubmit_BookingID": responseData.id,
                    "ReserveSubmit_CustomerName": customerName
                });
                return true;
            }
        } catch (error) {
            showError('Please try again later');
            console.error('Error hitting the API:', error);
            return false;
        }
    }

    function stValidateName() {
        const customerName = stInventoryMiddle.querySelector('.selected-store-content .appmt-input-name');
        if (customerName.classList.contains('appmt-input-warning')) {
            customerName.classList.remove('appmt-input-warning');
        }
    }

    function stValidateEmail() {
        const customerEmail = stInventoryMiddle.querySelector('.selected-store-content .appmt-input-email');
        const emailValue = customerEmail.value.trim();

        if (customerEmail.classList.contains('appmt-input-warning')) {
            customerEmail.classList.remove('appmt-input-warning');
        }

        const isValidEmail = emailValue.includes('@');

        if (isValidEmail) {
            customerEmail.classList.remove('appmt-input-warning');
        }
    }

    function stValidateNumber(inputElement) {
        let value = inputElement.value.replace(/\D/g, ''); // Remove any non-numeric characters
        if (value.length > 10) {
            value = value.slice(0, 10); // Restrict to 10 digits
        }
        inputElement.value = value; 

        const customerNum = stInventoryMiddle.querySelector('.selected-store-content .appmt-input-num');
        if (value.length === 10) {
            if (customerNum.classList.contains('appmt-input-warning')) {
                customerNum.classList.remove('appmt-input-warning');
            }
        }
    }


    const stInventoryClose = () => {
        document.body.classList.remove('mm-no-scroll');
        stInventoryOverlay.classList.remove('show');
        stInventoryModal.classList.remove('show');
        stInventoryModal.classList.remove('hide');
        stInventoryMiddle.classList.remove('hide');
        stInventoryMiddle.classList.remove('show');
        stInventorySuccess.classList.remove('show');
    }
